module.exports = __webpack_public_path__ + "7726383dd12ac4f81db5d6befb276ea8.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/17-Betsolutions-Legend-of-Maasai.png
// module id = 1739
// module chunks = 2